import { render, staticRenderFns } from "./ExternalServiceList.vue?vue&type=template&id=2c304c4f"
import script from "./ExternalServiceList.vue?vue&type=script&lang=js"
export * from "./ExternalServiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports